import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import { initSentry } from '@/lib/sentry'

import { App } from '@/app'
import '@/i18n'
import '@/index.css'

// Initialize Sentry before React renders
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
